import { render, staticRenderFns } from "./CosmostakingModal.vue?vue&type=template&id=81484214&scoped=true&"
import script from "./CosmostakingModal.vue?vue&type=script&lang=js&"
export * from "./CosmostakingModal.vue?vue&type=script&lang=js&"
import style0 from "./CosmostakingModal.vue?vue&type=style&index=0&id=81484214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81484214",
  null
  
)

export default component.exports